import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Main_Color } from "../../Theme/Theme";
import ReactLoading from "react-loading";
import Backend from "../../Backend/Backend";
const backend = new Backend();

export default class Account extends Component {
  constructor() {
    super();
    this.state = {
      admindata: JSON.parse(localStorage.getItem("admindata")),
      username: "",
      logourl: "",
      company_name: "",
      mobile: "",
      email: "",
      alternate_mobile: "",
      id_type: "",
      idnumber: "",
      address_line_1: "",
      address_line_2: "",
      address_line_3: "",
      state: "",
      country: "",
      gst_active: false,
      gst_no: "",
      sgst: "",
      cgst: "",
      birth_date: "",
      pdf_password: "",
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({
      company_name: this.state.admindata.company_name,
      email: this.state.admindata.email,
      pdf_password: this.state.admindata.pdf_password,
      username: this.state.admindata.username,
      mobile: this.state.admindata.mobile,
      company_name: this.state.admindata.company_name,
      alternate_mobile: this.state.admindata.alternate_mobile,
      loading: false,
    });
  }

  load_profile() {
    var data = {
      authtoken: localStorage.getItem("token"),
      admin_id: localStorage.getItem("adminid"),
    };
    backend.load_profile(data).then((r2) => {
      this.setState({ loading: false });
      if (r2.error == "False") {
        this.setState({
          name: r2.data.name,
          logourl: r2.data.logourl,
          company_name: r2.data.company_name,
          mobile: r2.data.mobile,
          email: r2.data.email,
          alternate_mobile: r2.data.alternate_mobile,
          id_type: r2.data.id_type,
          idnumber: r2.data.idnumber,
          address_line_1: r2.data.split[0],
          address_line_2: r2.data.split[1],
          address_line_3: r2.data.split[2],
          state: r2.data.state,
          country: r2.data.country,
          gst_active: r2.data.gst_active,
          gst_no: r2.data.gst_no,
          sgst: r2.data.sgst,
          cgst: r2.data.cgst,
          birth_date: r2.data.birth_date,
          pdf_password: r2.data.pdf_password,
          loading: false,
        });
      }
    });
  }

  edit_profile() {
    this.setState({ loading: true });
    var data = {
      authtoken: localStorage.getItem("token"),
      admin_id: localStorage.getItem("adminid"),
    };
    var profiledetails = {
      name: this.state.name,
      company_name: this.state.company_name,
      cgst: this.state.gst_active == 1 ? this.state.cgst : 0,
      sgst: this.state.gst_active == 1 ? this.state.sgst : 0,
      email: this.state.email,
      alternate_mobile: this.state.alternate_mobile,
      state: this.state.state,
      country: this.state.country,
      gst_no: this.state.gst_no,
      pdf_password: this.state.pdf_password,
      gst_active: this.state.gst_active,
    };
    var addresss = [
      this.state.address_line_1,
      this.state.address_line_2,
      this.state.address_line_3,
    ];
    backend.update_profile(data, profiledetails, addresss).then((r2) => {
      if (r2 == "false") {
        this.load_profile();
      } else {
        this.load_profile();
      }
    });
  }

  render() {
    return (
      <div
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <div
          style={{
            padding: 40,
            paddingLeft: 10,
            fontSize: 30,
            flex: 1,
            paddingBottom: 0,
          }}
        >
          Account Setting
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              UserName
            </label>
            <InputText
              id="in"
              value={this.state.username}
              placeholder="Enter UserName"
              // onChange={(e) => this.setState({ name: e.target.value })}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              Company Name
            </label>
            <InputText
              id="in"
              placeholder="Enter Company Name"
              value={this.state.company_name}
              // onChange={(e) => this.setState({ company_name: e.target.value })}
            />
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              Mobile Number
            </label>
            <InputText
              id="in"
              placeholder="Enter Mobile Number"
              value={this.state.mobile}
              // onChange={(e) => this.setState({ mobile: e.target.value })}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              E-Mail
            </label>
            <InputText
              id="in"
              placeholder="Enter E-mail"
              value={this.state.email}
              // onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
        </div>

        <div style={{ flex: 1, display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              Alternate Mobile
            </label>
            <InputText
              id="in"
              placeholder="Enter Alternate Mobile"
              value={this.state.alternate_mobile}
              // onChange={(e) =>
              //   this.setState({ alternate_mobile: e.target.value })
              // }
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              paddingRight: 30,
            }}
          >
            <label htmlFor="in" style={{ marginBottom: 10 }}>
              PDF-Password
            </label>
            <InputText
              placeholder="Pdf-Password"
              value={this.state.pdf_password}
            />
          </div>
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* {this.state.loading == true ? (
            <div
              style={{
                height: "50px",
                width: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: Main_Color,
                borderRadius: 10,
                color: "#ffffff",
              }}
            >
              <ReactLoading
                type={"bars"}
                color={"#ffffff"}
                height={40}
                width={40}
              />
            </div>
          ) : (
            <div
              onClick={() => this.edit_profile()}
              style={{
                height: "50px",
                width: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: Main_Color,
                borderRadius: 10,
                color: "#ffffff",
              }}
            >
              Update Profile
            </div>
          )} */}
        </div>
      </div>
    );
  }
}
